import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageMeta from '../../components/PageMeta';
import { CONTACT_EMAIL, CONTACT_MAILTO } from '../../config/siteContact';
import './LegalPage.css';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const sections = t('privacy.sections', { returnObjects: true });

  return (
    <div className="legal-page">
      <PageMeta title={t('privacy.title')} description={t('privacy.intro')} path="/privacy" />
      <Header />
      <header className="legal-hero">
        <div className="legal-hero-inner">
          <h1 className="legal-hero-title">{t('privacy.title')}</h1>
          <p className="legal-updated">{t('privacy.updated')}</p>
        </div>
      </header>

      <main className="legal-main">
        <p className="legal-intro">{t('privacy.intro')}</p>

        {Array.isArray(sections) &&
          sections.map((block, index) => (
            <section key={block.h || index} className="legal-block">
              <h2>{block.h}</h2>
              {(Array.isArray(block.p) ? block.p : [block.p]).filter(Boolean).map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </section>
          ))}

        <p className="legal-contact">
          {t('privacy.contactPrefix')}{' '}
          <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>
          {' · '}
          <Link to="/contact">{t('privacy.contactPage')}</Link>
        </p>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
